<template>
<div class="image-select" :class="{ 'is-row': isRow }">
  <figure class="image is-96x96 is-circular">
    <img :src="imageUrl">
  </figure>
  <figure class="overlay image is-96x96 is-circular" v-if="loading">
    <spinner class="spinner"
    line-fg-color="#44c7f0" />
  </figure>
  <p class="has-text-centered"><a @click.prevent="editClicked">{{ title }}</a></p>
  <input type="file" name="profileImage"
    @change="filesChange($event.target.files)" accept="image/*"
    class="input-file" ref="profileImageUpload" />
</div>
</template>

<script>
import Spinner from 'vue-simple-spinner'
export default {
  props: {
    imageUrl: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    isRow: {
      type: Boolean,
      default: false
    }
  },
  components: { Spinner },
  methods: {
    editClicked () {
      const ele = this.$refs.profileImageUpload
      ele.click()
    },
    async filesChange (files) {
      const file = files[0]
      this.$emit('change', file)
    }
  }
}
</script>

<style lang="scss" scoped>

figure.image {
  margin-bottom: 8px;
  background-color: #ffffff;
}

.image-select {
  display: flex;
  flex-direction: column;
}

.image-select.is-row {
  flex-direction: row;
}

p {
}

.input-file {
  overflow: hidden;
  position: absolute;
  visibility: hidden;
}

.overlay {
  background-color: #777777aa;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
}

figure.overlay {
  margin-top: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/profile/image-edit.vue